import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import App from './pages/App';
import './style/index.css'


ReactDOM.render(
  <>
   <App/>
  </>,
  document.getElementById('root')
);

